import React from 'react'

import AccountsList from '../../components/accountsList/AccountsList'

const MyAccounts = props => <AccountsList myAccounts={true} {...props} />

export default MyAccounts
